export default __webpack_public_path__ + "static/media/Mattastico.ca34ba8b.jpg";